import Glide from "@glidejs/glide";
const glideInstances = {};

function initImageGallery(id) {
    glideInstances[id] = new Glide('#' + id, {
        type: 'carousel',
        bound: true,
        startAt: 0,
        gap: 0,
        perView: 1,
    });
    let images = document.getElementById(id);
    if (images && images.querySelector('.glide__slides').children.length > 1 && !document.querySelector('body').classList.contains('wp-admin')) {
        glideInstances[id].mount();
    }
}

export function moveGlide(whichWay, id) {
    glideInstances[id].go(whichWay);
}

window.initImageGallery = initImageGallery;